{
  "version": 1,
  "asset_id": "55dd8c17-7432-4f23-84e0-46d6ddb91478",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/55dd8c17-7432-4f23-84e0-46d6ddb91478/loc-plano-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/55dd8c17-7432-4f23-84e0-46d6ddb91478/loc-plano-1280.avif",
  "original_filename": "loc-plano-1280.avif",
  "size": 72036,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:31Z"
}
